/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useRef, useEffect } from "react";
import { Toast } from "primereact/toast";
import LoadingOverlay from "react-loading-overlay-ts";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { BreadCrumb } from "primereact/breadcrumb";
import { addLocale } from "primereact/api";
import "../index.scss";
import "../../Tasks/TaskList/index.scss";

import TabsComponent from "./tabsComponent";
import CapacityManagementHeader from "./CapacityManagementHeader";
import {
  getAcpBookingData,
  updateRTATasks,
  updateEmptyErrorData,
  planningMassUpdate,
  massUpdateACPPlanningBooking,
  getACPDashboardProjectsRequiringPM,
  getAcpBookingBacklogData,
  getPMPicklistData,
  updatePMPicklistData,
  getACPDashboardAlerts,
} from "../../../apis/acpApi";
import AcpBookingDatatable from "../Booking/AcpBookingDatatable";
import AcpFooter from "./AcpFooter";
import { rowGroups, rowGroupsForDashboard, tabNamePageMapping } from "../constant";
import AcpDialog from "./AcpDialog";
import AcpCommonDialog from "./AcpCommonDialog";
import AcpPlanningDialog from "./Dialog/AcpPlanningDialog";
import AcceptBVEEndDateDialog from "../BveLoop/AcceptBVEEndDateDialog";
import CapacityManagementPlaningHeader from "../Planning/Header/CapacityManagementPlaningHeader";
import CapacityManagementSubHeader from "../Planning/CapacityManagementSubHeader";
import CdNavigation from "../Planning/Summary/CdNavigation";
import TaskAndProjectListNavigation from "../Planning/TaskAndProjectListNavigation";

import ACPBookingChart from "../Booking/ACPBookingChart";
import { AcpService } from "../../../service/ACPService";
import {
  acpPlanningSetDefaultFilters,
  setAcpPlanningTaskDraftData,
  setAcpPlanningProjectDraftData,
} from "../../../store/actions/AcpPlanningActions";
import AcpDashboard from "../Dashboard";
import { createDraftData } from "../../../service/ACPplanningService";
import {
  bookingRtaPayload,
  createPayloadData,
  creatMassUpdatePayload,
  getBuRegionList,
  removeAllLocalStorage,
  getValidBUList,
} from "../../../service/DashboardService";
//import { usePriorityNew } from "../../../Utils/GetRolePriority";
import UnAuthorizedComponent from "../../UnAuthorized/UnAuthorizedComponent";
import { isRoleMatch } from "../../../utils";
import { AcpCommonService } from "../../../service/AcpCommonService";
import { useUnsavedChangesWarning, UnsavedChangesDialog } from "../../common/NavigationPrompt";
import { cloneDeep } from "lodash";
import { dropDownValuesAction } from "../../../store/actions/dropDownValuesAction";
import { getDropDownValues } from "../../../apis/getDropDownValues";
import * as types from "../../../store/types/types";

function CapacityManagement(props) {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user_group = useSelector((state) => state?.UserDetailsReducer?.userDetails?.UserGroup);
  const {
    selectedBU,
    selectedDropdownValue,
    userDetails: { AccessGroup },
  } = useSelector((state) => state?.UserDetailsReducer);
  const { DropDownValuesData } = useSelector((state) => state?.DropDownValuesReducer);

  const { acpBookingData, acpDashboardProjectsRequiringPM, RTATasksUpdateError } = useSelector(
    (state) => state?.AcpBookingReducer
  );
  const [initiapPegaData, setInitiapPegaData] = useState([]);
  const [supplier, setSupplier] = useState([]);

  const projectSetup = useSelector((state) => state?.ProjectSetupReducer);
  const newStartDatesSaved = localStorage.getItem("NewStartDatesSaved");
  const selectedProjectDetails = projectSetup.selectedProject;
  const pmNameSaved = localStorage.getItem("PmNameSaved");
  const User = useSelector((state) => state.UserReducer);
  const locationPath = location?.pathname;
  const url = locationPath?.split("/");
  const [checkReadWriteAccess, setUserAccess] = useState(false);
  // const checkReadWriteAccess = isUserAccess; //usePriorityNew(location?.pathname?.split("/")?.[1]);
  const isCapacityManager = isRoleMatch(AccessGroup, ["CapacityManager"]);
  const toast = useRef(null);
  const [reset, setReset] = useState(false);
  const [Headers, setHeaders] = useState([]);
  const [filters, setFilters] = useState([]);
  const [loader, setLoader] = useState(false);
  const userInformation = User?.userInformation;
  const [visible, setVisible] = useState(false);
  const [editedRow, setEditedRow] = useState({});
  const [isSearch, isSearchSet] = useState(false);
  const [actionFlag, setActionFlag] = useState([]);
  const [expandAll, setExpandAll] = useState(true);
  const [bookingData, setBookingData] = useState([]);
  const [errorMsgArr, setErrorMsgArr] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [allEditedRows, setAllEditedRows] = useState([]);
  const [bookingTableData, setBookingTableData] = useState([]);
  const [showErrorDialog, setShowErrorDialog] = useState(false);
  const [editedRowPanelBottom, setEditedRowPanelBottom] = useState([]);
  const [selectedRowsPanelBottom, setSelectedRowsPanelBottom] = useState([]);
  const [allEditedRowsPanelBottom, setAllEditedRowsPanelBottom] = useState([]);
  const [dashboardPMTableData, setDashboardPMTableData] = useState([]);
  const [showAcpBookingDialog, setShowAcpBookingDialog] = useState(false);
  const [showAcpPlanDialog, setShowAcpPlanDialog] = useState(false);
  const [bookingTableFilters, setBookingTableFilters] = useState({});
  const [ShowCustomizedView, setShowCustomizedView] = useState(false);
  const [tabName, setTabName] = useState(url[2] !== undefined ? url[2] : url[1]);
  const [capacity, setCapacity] = useState(0);
  const [planningfilters, setPlanningfilters] = useState([]);
  const [isTaskData, setIsTaskData] = useState([]);
  const [isProjectData, setIsProjectData] = useState([]);
  const [isProjectListTab, setIsProjectListTab] = useState(true);
  const [saveFlag, setSaveFlag] = useState(true);
  const [applyFilters, setApplyFilters] = useState(false);
  const [exportTaskData, setExportTaskData] = useState([]);
  const [exportProjectData, setExportProjectData] = useState([]);
  const [planningData, setPlanningData] = useState({ isTask: true, planningData: [] });
  const [saveChangesOption, setSaveChangesOption] = useState(false);
  const [formValid, setFormValid] = useState(false);
  const [loadTaskTable, setLoadTaskTable] = useState(false);
  const [loadProjectTable, setLoadProjectTable] = useState(false);
  const [activeTable, setActiveTable] = useState("ProjectList");
  const [task, setTask] = useState();
  const [supplierValue, setSupplierValue] = useState();
  const [chartData, setChartData] = useState([]);
  const [chartClicked, setChartClicked] = useState(false);
  const [updatedBookingData, setUpdatedBookingData] = useState([]);
  const [range, setRange] = useState("");
  const [acpFilters, setAcpFilters] = useState({});
  const [activeTabSection, setActiveTabSection] = useState("");
  const [clearAllFilter, setClearAllFilter] = useState(false);
  const [modalType, setModalType] = useState("");
  const [actionType, setActionType] = useState("");
  const [suppliers, setSuppliers] = useState([]);
  const [resetMultiFilter, setResetMultiFilter] = useState(false);
  const [cancelCalled,setCancelCalled]=useState(false);
  const [showDraftDialog, setShowDraftDialog] = useState(false);
  const [taskData, setTaskData] = useState([]);
  const [changingTab, setChangingTab] = useState();
  const [onSave, setOnSave] = useState(false);
  const [dateChangeValue, setDateChangeValue] = useState([]);
  const { acpPlanningFilters, taskDraftChanges, projectDraftChanges } = useSelector(
    (state) => state?.AcpPlanningReducer
  );
  const [customizeViewFields, setCustomizeViewFields] = useState(
    localStorage.getItem("customizeViewFieldsBooking")
  );
  //placehoder for selected tasks and project from the table
  const [selectedTask, setSelectedTask] = useState([]);
  const [selectedProject, setSelectedProject] = useState([]);
  const [backlogData, setBacklogData] = useState([]);

  //set bu-region List
  const [buRegionList, setBuRegionList] = useState([]);
  const [validBu, setValidBu] = useState([]);
  //const [selectedBU, setSelectedBU]=useState({});

  //pickListData
  const [pmPicklistData, setPMPicklistData] = useState([]);
  const [dashboardAlerts, setDashboardAlerts] = useState([]);

  const [AllEditedTableDataRows, setAllEditedTableDataRows] = useState([]);
   const [capacityWrapFreeText, setcapacityWrapFreeText] = useState(() => {
      const saved = sessionStorage.getItem("capacityWrapFreeText");
      return saved === "true";
    });
   const [capacityPlanWrapFreeText, setcapacityPlanWrapFreeText] = useState(() => {
      const saved = sessionStorage.getItem("capacityPlanWrapFreeText");
      return saved === "true";
    });
  const {
    capacityManagementDashboard: isSearchDashboard,
    capacityManagementPlanning: isSearchPlanning,
    capacityManagementBooking: isSearchBooking,
  } = useSelector((state) => state?.SearchFilterReducer);
  //TODO: Below code should be refactored to make the component better
  const SavedFieldRefs = localStorage.getItem("_selectedFieldsRefCurrentBooking");
  const SavedFieldRefsParsed = SavedFieldRefs && JSON.parse(SavedFieldRefs);
  const SavedFieldPlaningRefs = localStorage.getItem("_selectedFieldsRefCurrentPlanning");
  const SavedFieldPlaningRefsParsed = SavedFieldPlaningRefs && JSON.parse(SavedFieldPlaningRefs);
  const SavedFieldRefsDashboardPanelTop = localStorage.getItem(
    "_selectedFieldsRefCurrentDashboardPanelTop"
  );
  const SavedFieldRefsDashboardPanelTopParsed =
    SavedFieldRefsDashboardPanelTop && JSON.parse(SavedFieldRefsDashboardPanelTop);
  const SavedFieldRefsDashboardPanelBottom = localStorage.getItem(
    "_selectedFieldsRefCurrentDashboardPanelBottom"
  );
  const SavedFieldRefsDashboardPanelBottomParsed =
    SavedFieldRefsDashboardPanelBottom && JSON.parse(SavedFieldRefsDashboardPanelBottom);

  // initial state for Awm-2907
  const [showDialog, setShowDialog] = useState(false);
  const isValid =
    tabName === "dashboard"
      ? (pmNameSaved && JSON.parse(pmNameSaved)?.length) || allEditedRows?.length 
      : tabName === "planning"
      ? dateChangeValue?.length &&
        (isTaskData?.length ||
          isProjectData?.length ||
          taskDraftChanges?.length ||
          projectDraftChanges?.length)
      : tabName === "booking"
      ? AllEditedTableDataRows?.length
      : false;

  // updating to AllEditedTableDataRows?.length condition 
  // as it has all the editedData    
  // this block will be used to show warning in sidebar if anything change
  // throut the acp pages dashboard, planning, booking
  const { markDirty, markClean } = useUnsavedChangesWarning();
  useEffect(() => {
    if (isValid) {
      markDirty();
    } else {
      markClean();
    }
  }, [tabName, pmNameSaved, allEditedRows, dateChangeValue]);

  useEffect(() => {
    markClean();
    // writing this line because on loading the pages we need to clear unsaveChanges localstorage
  }, []);

  useEffect(() => {
      if (DropDownValuesData === null) {
        (async () => {
          const allDropDown = await getDropDownValues();
          dispatch(dropDownValuesAction(allDropDown));
        })();
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [DropDownValuesData]);
            useEffect(() => {
            sessionStorage.setItem("capacityWrapFreeText", capacityWrapFreeText);
          }, [capacityWrapFreeText]);
            useEffect(() => {
            sessionStorage.setItem("capacityPlanWrapFreeText", capacityPlanWrapFreeText);
          }, [capacityPlanWrapFreeText]);
  // unsaved popup yes will confirmNavigation function AWM-2907
  const confirmNavigation = () => {
    markClean();
    handleCancel("cancel");
    setShowDialog(false);
    setAllEditedTableDataRows([]);
  };
  // unsaved popup no will cancelNavigation function AWM-2907
  const cancelNavigation = () => {
    setShowDialog(false);
  };

  addLocale("en", {
    firstDayOfWeek: 1,
  });
  const handleChartData = (data) => {
    setChartData(data);
  };
  const dashboardPMTableDataRefresh = () => {
    setLoader(true);
    fetchData();
    if (checkReadWriteAccess && validBu?.length) {
      fetchAcpBookingBacklog();
    }
  };
  useEffect(() => {
    if (acpPlanningFilters) {
      setFilters(acpPlanningFilters);
      setAcpFilters(acpPlanningFilters);
    }
  }, [acpPlanningFilters, activeTable]);

  useEffect(() => {
    const isUserAccess = isRoleMatch(AccessGroup, [
      "CapacityManager",
      "ProjectManager",
      "TaskOwner",
    ]);
    setUserAccess(isUserAccess);
  }, [AccessGroup]);

  const handleBeforeUnload = (event) => {
    if (showErrorDialog) {
      // Perform actions before the component unloads
      event.preventDefault();
      setShowErrorDialog(false);
      updateEmptyErrorData();
    }
  };
  useEffect(() => {
    if (showErrorDialog) {
      window.addEventListener("beforeunload", handleBeforeUnload);
    }
    return () => {
      if (!showErrorDialog) {
        window.removeEventListener("beforeunload", handleBeforeUnload);
      }
    };
  }, []);

  useEffect(() => {
    setTabName(url[2] !== undefined ? url[2] : url[1]);
  }, [url]);

  useEffect(() => {
    setExpandAll(true);
    removeAllLocalStorage();
    if (tabName === "planning") {
      setActiveTable("ProjectList");
    }
    setDateChangeValue([]);
  }, [tabName, validBu?.length, checkReadWriteAccess]);

  useEffect(() => {
    dispatch(acpPlanningSetDefaultFilters());
    if (taskDraftChanges?.length) {
      setSaveChangesOption(true);
      setSaveFlag(false);
    }
  }, []);

  useEffect(() => {
      const taskData = planningfilters?.length > 0 ? planningfilters : isTaskData?.length > 0?isTaskData:[];
      const projectData = planningfilters?.length > 0 ? planningfilters : isProjectData?.length > 0 ? isProjectData:[];
      if (!isProjectListTab) {
        setExportProjectData([]);
        setExportTaskData(taskData);
      } else if (isProjectListTab) {
        setExportTaskData([]);
        setExportProjectData(projectData);
      }
  }, [planningfilters, isTaskData, isProjectData]);

  useEffect(() => {
    setExportProjectData([]);
    setExportTaskData([]);
  }, [clearAllFilter]);

  const handleMessClick = (type) => {
    setModalType(type);
    setShowAcpBookingDialog(true);
  };
  const handleMessUpPlan = () => {
    setShowAcpPlanDialog(true);
  };

  const fetchAcpBookingBacklog = async () => {
    if (tabName === "booking") {
      setLoader(true);
      const budetails = selectedBU?.length ? selectedBU : validBu;
      const response = await getAcpBookingBacklogData(userInformation, budetails);
      if (response?.length) {
        const data = response.map((el, i) => ({
          ...el,
          UniqueID: "Backlog_" + i,
        }));
        setBacklogData(data);
      } else {
        setBacklogData([]);
      }
    }
  };

  const fetchData = async () => {
    const budetails = selectedBU?.length ? selectedBU : validBu;
    if (
      (buRegionList?.length && buRegionList?.length === 1) ||
      (buRegionList?.length &&
        buRegionList?.length > 1 &&
        !AcpService.isUBN(selectedDropdownValue) &&
        Object.keys(selectedDropdownValue)?.length)
    ) {
      if (tabName === "booking") {
        setLoader(true);
        await getAcpBookingData(userInformation, budetails, bookingTableFilters);
        setLoader(false);
      }
      if (tabName === "dashboard") {
        setLoader(true);
        await getACPDashboardProjectsRequiringPM(budetails);
        getPMPicklistData(budetails).then((data) => {
          setPMPicklistData(data);
        });
        setLoader(false);
        const res = await getACPDashboardAlerts(budetails);
        if (res && Object.keys(res)?.length) {
          setDashboardAlerts(res);
        } else {
          setDashboardAlerts([]);
        }
      }
      // if (tabName === "bveLoop") {
      //   let { offTractBVELoop, onTractBVELoop } = await getBVELoopData(userInformation, budetails);
      //   let { tempOnTrack, tempOffTrack } = createGroupForBVELoop(offTractBVELoop, onTractBVELoop);
      //   if (tempOnTrack?.length && tempOffTrack?.length) {
      //     setBVELoopTableData([...tempOnTrack, ...tempOffTrack]);
      //   }
      // }
    }
    setAllEditedRowsPanelBottom([]);
    setAllEditedRows([]);
    setLoader(false);
  };

  const onSubmit = async () => {
    setLoader(true);
    setSaveChangesOption(false);
    setDateChangeValue([]);
    setAllEditedTableDataRows([]);
    const preSelectedRows =
      tabName === "dashboard"
        ? pmNameSaved && JSON.parse(pmNameSaved)
        : newStartDatesSaved && JSON.parse(newStartDatesSaved);

    const updatedSelectedData =
      tabName === "dashboard"
        ? allEditedRows.map((el) => {
            return { ...el, PmName: el.PmName?.name };
          })
        : allEditedRows
            .map((el) => {
              return {
                ...el,
                StartDate:
                  !AcpService.isUBN(el?.StartDate) && !AcpService.checkIfValidDate(el?.StartDate)
                    ? AcpService.formatDate(el?.StartDate)
                    : AcpService.convertDate(new Date(el?.StartDate)),
              };
            })
            .filter((item) => item?.StartDate !== "Invalid date"); //Filters this data array to include only those objects or elements where the StartDate property is not Invalid date, for AWM-3217
    const firstData =
      actionType === "inlineUpdate"
        ? updatedSelectedData
        : preSelectedRows?.length
        ? preSelectedRows
        : [];
    const secondData =
      actionType === "inlineUpdate"
        ? preSelectedRows?.length
          ? preSelectedRows
          : []
        : updatedSelectedData;
    const filteredSelectedData = AcpService.findUniqueObjects(firstData, secondData, "UniqueID");
    // for booking page no additional calculation required 
    // as AllEditedTableDataRows have all the data inline+mass, 
    // so directly converting their startDates if not in GMT
    const allEditedDataWithGMTDateFormat = AllEditedTableDataRows.map((el) => {
      const startDate = el.StartDate;
      if (!AcpService.isUBN(el?.StartDate) && !startDate.includes('GMT')) {
        el.StartDate = AcpService.convertDate(new Date(el?.StartDate));
      }
      return {
        ...el,
        StartDate: el?.StartDate,
      };
    })
    if (tabName === "dashboard") {
      const finalData = filteredSelectedData?.map((el) => {
        return {
          AWMProjectID: el?.AWMProjectID,
          PM: el?.PM?.name ? el?.PM?.name : el?.PmName,
        };
      });
      let obj = {};
      obj["NewPM"] = finalData;
      const pmStatus = await updatePMPicklistData(obj);

      if (pmStatus) {
        setTimeout(() => {
          fetchData();
          if (checkReadWriteAccess && validBu?.length) {
            fetchAcpBookingBacklog();
          }
        }, 1000);
      }
      localStorage.setItem("PmNameSaved", JSON.stringify([]));
      setLoader(false);
    } else if (tabName === "planning") {
      massUpdatePlanningData();
    } else {
      setReset(!reset);
      const rtaData = allEditedDataWithGMTDateFormat.filter((el) => el?.POANumber);
      const massUpdateData = allEditedDataWithGMTDateFormat.filter((el) => !el?.POANumber);
      const finalData = creatMassUpdatePayload(massUpdateData);
      let massUpdateStatus = false;
      if (finalData?.length > 0) {
        const { response } = await massUpdateACPPlanningBooking({ NewStartDates: finalData });
        if (response?.status === 200) {
          massUpdateStatus = true;
          localStorage.setItem("NewStartDatesSaved", JSON.stringify([]));
        }
      }
      let submitRows = [];
      let rtaStatus = false;
      if (rtaData?.length) {
        submitRows = bookingRtaPayload(rtaData, tabName);
        const submitData = {
          RTATasksPage: submitRows,
        };
        await updateRTATasks(submitData);
        rtaStatus = true;
      }
      if (massUpdateStatus || rtaStatus) {
        localStorage.removeItem("NewStartDatesSaved");
        setAllEditedRows([]);
        clearFilter();
        setTimeout(() => {
          fetchData();
          if (checkReadWriteAccess && validBu?.length) {
            fetchAcpBookingBacklog();
          }
        }, 1000);
      }
    }
    setVisible(false);
  };
  const [resetKey, setResetKey] = useState(0);

  const handleChildClick = (isClicked) => {
    if (!isClicked) {
      clearFilter();
      setResetKey((prev) => prev + 1);
    }
  };
  const massUpdatePlanningData = async () => {
    const taskData = isTaskData
      ?.map((item) => {
        return {
          ...item,
          NewStartDate:
            !AcpService.isUBN(item?.NewStartDate) && AcpService.checkIfValidDate(item?.NewStartDate)
              ? AcpCommonService.convertToDate(item?.NewStartDate)
              : item?.NewStartDate,
        };
      })
      .filter((item) => item?.NewStartDate !== null); // Filters this array to include only those objects or elements where the NewStartDate property is not null, for AWM-3217
    const projectData = isProjectData
      ?.map((item) => {
        return {
          ...item,
          NewStartDate:
            !AcpService.isUBN(item?.NewStartDate) && AcpService.checkIfValidDate(item?.NewStartDate)
              ? AcpCommonService.convertToDate(item?.NewStartDate)
              : item?.NewStartDate,
        };
      })
      .filter((item) => item?.NewStartDate !== null); // Filters this array to include only those objects or elements where the NewStartDate property is not null, for AWM-3217
    const massUpdatetaskData = taskData?.filter((el) => !el?.POANumber);
    const rtaData = taskData?.filter((el) => el?.POANumber);
    if (taskData?.length && activeTable === "TaskList") {
      if (rtaData?.length) {
        const payload = createPayloadData(rtaData);
        if (payload?.length > 0) {
          const submitData = {
            RTATasksPage: payload,
          };
          let res = await updateRTATasks(submitData);
          if (res) {
            setLoadTaskTable(true);
            setIsTaskData([]);
          } else {
            setLoadTaskTable(true);
            setIsTaskData([]);
          }
          //need to handle error scenario
        } else {
          setLoadTaskTable(true);
          setIsTaskData([]);
        }
      }
      if (massUpdatetaskData?.length) {
        planningMassUpdate(massUpdatetaskData, "Task").then(() => {
          setLoadTaskTable(true);
          setIsTaskData([]);
        });
      }
    } else if (projectData?.length) {
      planningMassUpdate(projectData, "Project").then(() => {
        setLoadProjectTable(true);
        setIsProjectData([]);
      });
    }
  };

  const checkDraftChanges = (item) => {
    if (
      (isTaskData?.length && isTaskData?.length > taskDraftChanges?.length) ||
      (isProjectData?.length && isProjectData?.length > projectDraftChanges?.length)
    ) {
      setShowDraftDialog(true);
      setChangingTab(item);
      return true;
    } else {
      return false;
    }
  };

  useEffect(() => {
    if (RTATasksUpdateError === "null") {
      return;
    } else if (RTATasksUpdateError?.length > 0) {
      setShowErrorDialog(true);
      setErrorMsgArr(RTATasksUpdateError);
    } else if (RTATasksUpdateError?.length === 0 && validBu?.length && userInformation?.userid) {
      setLoader(true);
      fetchData();
      checkReadWriteAccess && fetchAcpBookingBacklog();
      setErrorMsgArr([]);
    }
  }, [RTATasksUpdateError, validBu?.length, userInformation?.userid]);

  const handleCancel = (callFrom) => {
    if (tabName !== "booking") {
      setDateChangeValue([]);
    }
    if (tabName === "planning") {
      setSaveFlag(false);
    }
    if (tabName === "dashboard" && callFrom === "cancel") {
      setAllEditedRows([]);
      setEditedRow([]);
      setSelectedRows([]);
      setCancelCalled(true)
      const data = cloneDeep(acpDashboardProjectsRequiringPM);
      setDashboardPMTableData(data);
    }
    if (!AcpService.isUBN(callFrom) && callFrom === "cancel") {
      setReset(!reset);
      setDateChangeValue([]);
      setAllEditedTableDataRows([]);
      localStorage.setItem("NewStartDatesSaved", JSON.stringify([]));
    }
  };

  const handleCancelClick = () => {
    if (isValid) {
      setShowDialog(true);
    } else {
      handleCancel("cancel");
    }
  };

  const onSaveAsDraft = () => {
    let data = activeTable === "TaskList" ? isTaskData : isProjectData;
    if (data.length > 0) {
      const draftData = createDraftData(data);
      if (draftData.length > 0) {
        if (activeTable === "TaskList") {
          dispatch(setAcpPlanningTaskDraftData(draftData));
        } else {
          dispatch(setAcpPlanningProjectDraftData(draftData));
        }
      }
    }
    setSaveFlag(false);
  };

  const orderByGroupOrder = (data) => {
    return data?.sort(function (a, b) {
      return a?.GroupOrder - b?.GroupOrder;
    });
  };

  useEffect(() => {
    //3648 - reset to initial Filters on tab change
    const initialFilters = AcpService.getInitialFilterState();
    setAcpFilters(initialFilters);
    if (tabName === "dashboard") {
      setDashboardPMTableData(acpDashboardProjectsRequiringPM);
    } else {
      let temp = [];
      if (acpBookingData?.length) {
        let groups = Object.keys(acpBookingData[0]);
        groups.forEach((group) => {
          acpBookingData[0][group].forEach((obj) => {
            obj["Group"] = group;
            obj["GroupOrder"] = rowGroups.filter((grp) => {
              return grp.id === group;
            })?.[0]?.order;
            temp.push(obj);
          });
        });
      }
      const data = orderByGroupOrder(temp).map((el, i) => ({
        ...el,
        UniqueID: i,
      }));
      setBookingTableData(data);
      // setBookingTableData(orderByGroupOrder(temp));
    }
  }, [acpBookingData, acpDashboardProjectsRequiringPM, tabName]);

  useEffect(() => {
    if(bookingTableFilters?.callAPi === false){
      if (
        (tabName &&
          bookingTableFilters?.endDate &&
          bookingTableFilters?.Date &&
          validBu?.length &&
          userInformation?.userid) ||
        (!AcpService.isUBN(selectedDropdownValue) &&
          Object.keys(selectedDropdownValue)?.length &&
          tabName === "dashboard")
      ) {
        // setLoader(true);
        fetchData();
        if (checkReadWriteAccess && validBu?.length) {
          fetchAcpBookingBacklog();
        }
      }
    }
  }, [
    tabName,
    bookingTableFilters?.callAPi,
    validBu?.length,
    userInformation?.userid,
    selectedDropdownValue,
  ]);

  useEffect(() => {
    if (user_group?.length) {
      const validBUList = getValidBUList(user_group);
      setValidBu(validBUList);
      const burRegionData = getBuRegionList(user_group);
      setBuRegionList(burRegionData);
      if (
        tabName !== "dashboard" &&
        validBUList?.length &&
        validBUList?.length > 1 &&
        !AcpService.isUBN(selectedDropdownValue) &&
        !Object.keys(selectedDropdownValue)?.length
      ) {
        navigate("/capacityManagement/dashboard");
      }
    }
  }, [user_group]);

  const onSearchClick = () => {
    dispatch({ type: types.ALTER_SEARCH_FILTER, page: tabNamePageMapping[tabName] });
  };

  const childFunc = useRef(null);
  // remove All filters and reset all the state
  const clearFilter = () => {
    setClearAllFilter(true);
    dispatch({ type: types.HIDE_SEARCH_FILTER, page: tabNamePageMapping[tabName] });
    if (tabName !== "planning") {
      handleCancel();
    }
    if (tabName === "dashboard") {
      //setLoader(true);
      removeAllLocalStorage([
        // "sortedColumnDashboardPanelTop",
        // "sortedColumnDashboardPanelBottom",
        "_selectedFieldsRefCurrentDashboardPanelTop",
        "_selectedFieldsRefCurrentDashboardPanelBottom",
      ]);
      // setTimeout(() => {
      //   setLoader(false);
      // }, 100);// to keep the selection
    } else if (tabName === "booking") {
      setLoader(true);
      childFunc?.current?.clear();
      removeAllLocalStorage(["sortedColumnBooking", "_selectedFieldsRefCurrentBooking"]);
      setTimeout(() => {
        setLoader(false);
      }, 100);
    } else {
      setLoader(true);
      childFunc?.current?.clear();
      setCustomizeViewFields(null);
      removeAllLocalStorage([
        //"sortedColumnBooking",
        "_selectedFieldsRefCurrentBooking",
      ]);
      setTimeout(() => {
        setLoader(false);
      }, 100);
    }
  };

  // const isFilterEnabled =
  //   frozenCoulmns?.length || filters?.length || sortData?.length || isSearch;

  const _items = [
    { label: "Capacity Management" },
    { label: tabName.charAt(0).toUpperCase() + tabName.slice(1) },
  ];

  const selectedBarData = (data, flag) => {
    if (data === undefined) return;
    setUpdatedBookingData(data);
    setChartClicked(flag);
  };

  const showReportToast = (message, type) => {
    if (toast.current) {
      toast.current.show({
        severity: !AcpService.isUBN(type) ? type : "success",
        summary: message,
        detail: !AcpService.isUBN(type) ? "Error!" : "Successful!",
        life: 3000,
      });
    }
  };

  const onHide = () => {
    if (modalType === "ManageCapacity" || modalType === "UploadLongTermPlan") {
      setAllEditedRows([]);
      setEditedRow([]);
      const data = cloneDeep(acpDashboardProjectsRequiringPM);
      setDashboardPMTableData(data);
      setReset(!reset);
    }
  };

  const itemsData = [
    {
      name: "dashboard",
      tabNameForDisplay: "Dashboard",
      component: tabName === "dashboard" && (
        <>
          {checkReadWriteAccess ? (
            <LoadingOverlay active={loader} spinner text="">
              <div className="capacity-main">
                <div className="projectSetupParent project-plan-wrapper acp-main">
                  <div className="col">
                    {selectedProjectDetails !== undefined && (
                      <CapacityManagementHeader
                        isSearch={isSearchDashboard}
                        header=""
                        range={range}
                        loader={loader}
                        headers={Headers}
                        tabName={tabName}
                        filterFLag={false}
                        capacity={capacity}
                        buRegionList={buRegionList}
                        userGroup={user_group}
                        validatedBuList={validBu}
                        isCapacityManager={isCapacityManager}
                        selectedDropdownValue={selectedDropdownValue}
                        editedRow={editedRow}
                        setLoader={setLoader}
                        allData={bookingData}
                        expandAll={expandAll}
                        suppliers={suppliers}
                        isDashboardPage={true}
                        isTreeTableFlag={true}
                        isResetEnabled={false}
                        actionType={actionType}
                        actionFlag={actionFlag}
                        setVisible={setVisible}
                        clearFilters={() => {}}
                        saveSettings={() => {}}
                        demand={chartData?.length}
                        bookingData={bookingData}
                        CustomizeViewFlag={false}
                        clearFilter={clearFilter}
                        hideCustomizedView={true}
                        ResetToDefaultFlag={false}
                        setSuppliers={setSuppliers}
                        selectedRows={selectedRows}
                        setEditedRow={setEditedRow}
                        setExpandAll={setExpandAll}
                        rightSideHeadersOnly={true}
                        onSearchClick={onSearchClick}
                        allEditedRows={allEditedRows}
                        setActionType={setActionType}
                        handleMessClick={handleMessClick}
                        setAllEditedRows={setAllEditedRows}
                        customizeViewFields={customizeViewFields}
                        editedRowPanelBottom={editedRowPanelBottom}
                        setShowCustomizedView={setShowCustomizedView}
                        setBookingTableFilters={setBookingTableFilters}
                        setCustomizeViewFields={setCustomizeViewFields}
                        selectedRowsPanelBottom={selectedRowsPanelBottom}
                        setEditedRowPanelBottom={setEditedRowPanelBottom}
                        allEditedRowsPanelBottom={allEditedRowsPanelBottom}
                        setSelectedRowsPanelBottom={setSelectedRowsPanelBottom}
                        setAllEditedRowsPanelBottom={setAllEditedRowsPanelBottom}
                        isFilterEnabled={
                          isSearchDashboard ||
                          SavedFieldRefsDashboardPanelTopParsed?.length ||
                          SavedFieldRefsDashboardPanelBottomParsed?.length
                        }
                        onChildClick={handleChildClick}
                        formValid={isValid}
                        setDateChangeValue={setDateChangeValue}
                      />
                    )}
                  </div>
                  <div>
                    <AcpDashboard
                      pmPicklistData={pmPicklistData}
                      reset={reset}
                      loader={loader}
                      ref={childFunc}
                      Headers={Headers}
                      tabName={tabName}
                      isSearch={isSearchDashboard}
                      fetchData={fetchData}
                      setLoader={setLoader}
                      editedRow={editedRow}
                      expandAll={expandAll}
                      suppliers={suppliers}
                      actionType={actionType}
                      setHeaders={setHeaders}
                      isSearchSet={isSearchSet}
                      bookingData={dashboardPMTableData}
                      dashboardAlerts={dashboardAlerts}
                      setSuppliers={setSuppliers}
                      setEditedRow={setEditedRow}
                      chartClicked={chartClicked}
                      selectedRows={selectedRows}
                      setExpandAll={setExpandAll}
                      setActionType={setActionType}
                      allEditedRows={allEditedRows}
                      setActionFlag={setActionFlag}
                      setChartData={handleChartData}
                      clearAllFilter={clearAllFilter}
                      setBookingData={setBookingData}
                      setSelectedRows={setSelectedRows}
                      rowGroups={rowGroupsForDashboard}
                      setAllEditedRows={setAllEditedRows}
                      bookingTableData={dashboardPMTableData}
                      setClearAllFilter={setClearAllFilter}
                      ShowCustomizedView={ShowCustomizedView}
                      updatedBookingData={updatedBookingData}
                      setBookingTableData={setBookingTableData}
                      bookingTableFilters={bookingTableFilters}
                      customizeViewFields={customizeViewFields}
                      checkReadWriteAccess={isCapacityManager}
                      showAcpBookingDialog={showAcpBookingDialog}
                      editedRowPanelBottom={editedRowPanelBottom}
                      setShowCustomizedView={setShowCustomizedView}
                      setBookingTableFilters={setBookingTableFilters}
                      setCustomizeViewFields={setCustomizeViewFields}
                      setShowAcpBookingDialog={setShowAcpBookingDialog}
                      selectedRowsPanelBottom={selectedRowsPanelBottom}
                      setEditedRowPanelBottom={setEditedRowPanelBottom}
                      allEditedRowsPanelBottom={allEditedRowsPanelBottom}
                      setSelectedRowsPanelBottom={setSelectedRowsPanelBottom}
                      setAllEditedRowsPanelBottom={setAllEditedRowsPanelBottom}
                      selectedDropdownValue={selectedDropdownValue}
                      resetKey={resetKey}
                      cancelCalled={cancelCalled}
                      setCancelCalled={setCancelCalled}
                    />
                  </div>
                </div>
                <AcpFooter
                  onSubmit={onSubmit}
                  handleCancel={handleCancelClick}
                  checkReadWriteAccess={isCapacityManager}
                  formValid={isValid}
                  selectedRows={selectedRows}
                />
              </div>
            </LoadingOverlay>
          ) : (
            AccessGroup && AccessGroup?.length && <UnAuthorizedComponent nowrapper={true} />
          )}
        </>
      ),
    },
    {
      name: "planning",
      tabNameForDisplay: "Planning",
      component: tabName === "planning" && (
        <>
          {checkReadWriteAccess ? (
            <div className="acp-planning-page">
              <div className="projectSetupParent project-plan-wrapper acp-main">
                <div className="headerWrapper">
                  {filters && (
                    <CapacityManagementPlaningHeader
                      initiapPegaData={initiapPegaData}
                      setInitiapPegaData={setInitiapPegaData}
                      supplier={supplier}
                      setSupplier={setSupplier}
                      filters={filters}
                      setFilters={setFilters}
                      setAcpFilters={setAcpFilters}
                      acpFilters={acpFilters}
                      setTask={setTask}
                      setSupplierValue={setSupplierValue}
                      isProjectListTab={isProjectListTab}
                      PM={userInformation?.userid}
                      showDraftDialog={showDraftDialog}
                      setShowDraftDialog={setShowDraftDialog}
                      activeTable={activeTable}
                      isTaskData={isTaskData}
                      isProjectData={isProjectData}
                      applyFilters={applyFilters}
                      setClearAllFilter={setClearAllFilter}
                      setApplyFilters={setApplyFilters}
                      UserGroup={validBu?.length > 1 ? selectedBU?.length && selectedBU : validBu}
                      onChildClick={handleChildClick}
                      formValid={isValid}
                      setDateChangeValue={setDateChangeValue}
                      handleCancel={handleCancel}
                    />
                  )}
                  <div className="capacityManagement">
                    <CapacityManagementSubHeader
                      handleMessUpPlan={handleMessUpPlan}
                      activeTabSection={activeTabSection}
                      planningData={planningData}
                      isTaskData={exportTaskData}
                      isProjectData={exportProjectData}
                      isSearch={isSearchPlanning}
                      selectedTask={selectedTask}
                      selectedProject={selectedProject}
                      isSearchSet={isSearchSet}
                      activeTable={activeTable}
                      setClearAllFilter={setClearAllFilter}
                      isFilterEnabled={isSearchPlanning || SavedFieldPlaningRefsParsed?.length}
                      onChildClick={handleChildClick}
                      formValid={isValid}
                      Headers={Headers}
                      setHeaders={setHeaders}
                      setShowCustomizedView={setShowCustomizedView}
                      capacityPlanWrapFreeText={capacityPlanWrapFreeText}
                      setcapacityPlanWrapFreeText={setcapacityPlanWrapFreeText}
                    />
                  </div>
                </div>
                {filters && (
                  <CdNavigation
                    activeTable={activeTable}
                    filters={acpFilters}
                    isTaskData={isTaskData}
                    isProjectData={isProjectData}
                    setIsTaskData={setIsTaskData}
                    setIsProjectData={setIsProjectData}
                    task={task}
                    supplierValue={supplierValue}
                    PM={userInformation.userid}
                    UserGroup={validBu?.length > 1 ? selectedBU?.length && selectedBU : validBu}
                    reset={reset}
                    taskData={taskData}
                    setTaskData={setTaskData}
                    setSaveFlag={setSaveFlag}
                    saveFlag={saveFlag}
                    allEditedRowsPlanning={AllEditedTableDataRows}
                    capacityPlanWrapFreeText={capacityPlanWrapFreeText}
                    setcapacityPlanWrapFreeText={setcapacityPlanWrapFreeText}
                  />
                )}

                {/* C-D, Capacity, Demand Tables inside above component*/}
                <TaskAndProjectListNavigation
                  initiapPegaData = {initiapPegaData}
                  setInitiapPegaData = {setInitiapPegaData}
                  supplier={supplier}
                  setSupplier={setSupplier}
                  parentFilter={filters}
                 activeTabSection={activeTabSection}
                 setActiveTabSection={setActiveTabSection}
                  setIsTaskData={setIsTaskData}
                  isTaskData={isTaskData}
                  isProjectData={isProjectData}
                  setIsProjectData={setIsProjectData}
                  setIsProjectListTab={setIsProjectListTab}
                  isSearch={isSearchPlanning}
                  activeTable={activeTable}
                  saveChangesOption={saveChangesOption}
                  setSaveChangesOption={setSaveChangesOption}
                  loadTaskTable={loadTaskTable}
                  setLoadTaskTable={setLoadTaskTable}
                  setLoadProjectTable={setLoadProjectTable}
                  setPlanningData={setPlanningData}
                  loadProjectTable={loadProjectTable}
                  acpFilters={acpFilters}
                  task={task}
                  setTask={setTask}
                  supplierValue={supplierValue}
                  reset={reset}
                  setReset={setReset}
                  setActiveTable={setActiveTable}
                  filters={planningfilters}
                  setFilters={setPlanningfilters}
                  selectedTask={selectedTask}
                  setSelectedTask={setSelectedTask}
                  selectedProject={selectedProject}
                  setSelectedProject={setSelectedProject}
                  PM={userInformation?.userid}
                  UserGroup={validBu?.length > 1 ? selectedBU?.length && selectedBU : validBu}
                  setFormValid={setFormValid}
                  saveFlag={saveFlag}
                  setSaveFlag={setSaveFlag}
                  showDraftDialog={showDraftDialog}
                  setShowDraftDialog={setShowDraftDialog}
                  tabName={tabName}
                  clearAllFilter={clearAllFilter}
                  setClearAllFilter={setClearAllFilter}
                  taskData={taskData}
                  setTaskData={setTaskData}
                  setApplyFilters={setApplyFilters}
                  changingTab={changingTab}
                  setChangingTab={setChangingTab}
                  setTabName={setTabName}
                  checkReadWriteAccess={isCapacityManager}
                  resetKey={resetKey}
                  Headers={Headers}
                  setHeaders={setHeaders}
                  setResetKey={setResetKey}
                  setDateChangeValue={setDateChangeValue}
                  allEditedRowsPlanning={AllEditedTableDataRows}
                  setAllEditedRowsPlanning={setAllEditedTableDataRows}
                  ShowCustomizedView={ShowCustomizedView}
                  setShowCustomizedView={setShowCustomizedView}
                  availableAcpColumns={DropDownValuesData?.ArtworkAgilityACPPage}
                  capacityPlanWrapFreeText={capacityPlanWrapFreeText}
                  setcapacityPlanWrapFreeText={setcapacityPlanWrapFreeText}
                />

                {/* Task List and Project List Tables inside above component*/}
              </div>
              <AcpFooter
                onSubmit={() => onSubmit()}
                onSaveAsDraft={() => onSaveAsDraft()}
                handleCancel={() => handleCancelClick()}
                checkReadWriteAccess={saveChangesOption}
                formValid={isValid}
                identifier={"PlanningPage"}
                saveFlag={saveFlag}
                selectedTask={selectedTask}
                selectedProject={selectedProject}
              />
            </div>
          ) : (
            AccessGroup && AccessGroup?.length && <UnAuthorizedComponent nowrapper={true} />
          )}
        </>
      ),
    },
    {
      name: "booking",
      tabNameForDisplay: "Booking",
      component: tabName === "booking" && (
        <>
          {checkReadWriteAccess ? (
            <>
              <div className="booking-header">
                <BreadCrumb
                  home={{}}
                  model={_items}
                  className="booking-breadcrumb"
                  separatorIcon={<i className="pi pi-angle-right"></i>}
                />
              </div>
              <LoadingOverlay active={loader} spinner text="">
                <div className="capacity-main">
                  <div className="projectSetupParent project-plan-wrapper acp-main">
                    <div className="col">
                      {selectedProjectDetails !== undefined && (
                        <CapacityManagementHeader
                          isSearch={isSearchBooking}
                          header=""
                          range={range}
                          loader={loader}
                          headers={Headers}
                          tabName={tabName}
                          buRegionList={buRegionList}
                          userGroup={user_group}
                          selectedDropdownValue={selectedDropdownValue}
                          validatedBuList={validBu}
                          isCapacityManager={isCapacityManager}
                          filterFLag={false}
                          capacity={capacity}
                          suppliers={suppliers}
                          editedRow={editedRow}
                          setLoader={setLoader}
                          allData={bookingData}
                          expandAll={expandAll}
                          isTreeTableFlag={true}
                          isResetEnabled={false}
                          actionFlag={actionFlag}
                          setVisible={setVisible}
                          actionType={actionType}
                          clearFilters={() => {}}
                          saveSettings={() => {}}
                          demand={chartData?.length}
                          bookingData={bookingData}
                          CustomizeViewFlag={false}
                          clearFilter={clearFilter}
                          ResetToDefaultFlag={false}
                          selectedRows={selectedRows}
                          setSuppliers={setSuppliers}
                          setEditedRow={setEditedRow}
                          setExpandAll={setExpandAll}
                          onSearchClick={onSearchClick}
                          allEditedRows={allEditedRows}
                          setActionType={setActionType}
                          clearAllFilter={clearAllFilter}
                          handleMessClick={handleMessClick}
                          setAllEditedRows={setAllEditedRows}
                          resetMultiFilter={resetMultiFilter}
                          setResetMultiFilter={setResetMultiFilter}
                          customizeViewFields={customizeViewFields}
                          setShowCustomizedView={setShowCustomizedView}
                          setBookingTableFilters={setBookingTableFilters}
                          setCustomizeViewFields={setCustomizeViewFields}
                          AllEditedTableDataRows={AllEditedTableDataRows}
                          setAllEditedTableDataRows={setAllEditedTableDataRows}
                          isFilterEnabled={isSearchBooking || SavedFieldRefsParsed?.length}
                          onChildClick={handleChildClick}
                          formValid={isValid}
                          setDateChangeValue={setDateChangeValue}
                          handleCancel={handleCancel}
                          capacityWrapFreeText={capacityWrapFreeText}
                          setcapacityWrapFreeText={setcapacityWrapFreeText}
                        />
                      )}
                    </div>
                    {true ? (
                      <>
                        <ACPBookingChart
                          reset={reset}
                          setRange={setRange}
                          chartData={chartData}
                          UserGroup={
                            validBu?.length > 1 ? selectedBU?.length && selectedBU : validBu
                          }
                          backlogData={backlogData}
                          setCapacity={setCapacity}
                          PM={userInformation?.userid}
                          selectedBarData={selectedBarData}
                          resetMultiFilter={resetMultiFilter}
                          setResetMultiFilter={setResetMultiFilter}
                          bookingTableFilters={bookingTableFilters}
                        />
                        <AcpBookingDatatable
                          reset={reset}
                          loader={loader}
                          ref={childFunc}
                          Headers={Headers}
                          tabName={tabName}
                          isSearch={isSearchBooking}
                          rowGroups={rowGroups}
                          setResetKey={setResetKey}
                          UserGroup={validBu?.length > 1 ? selectedBU?.length && selectedBU : validBu}
                          fetchData={fetchData}
                          setLoader={setLoader}
                          editedRow={editedRow}
                          expandAll={expandAll}
                          suppliers={suppliers}
                          setHeaders={setHeaders}
                          actionType={actionType}
                          backlogData={backlogData}
                          isSearchSet={isSearchSet}
                          bookingData={bookingData}
                          setSuppliers={setSuppliers}
                          setEditedRow={setEditedRow}
                          chartClicked={chartClicked}
                          selectedRows={selectedRows}
                          setExpandAll={setExpandAll}
                          allEditedRows={allEditedRows}
                          setActionType={setActionType}
                          setActionFlag={setActionFlag}
                          setChartData={handleChartData}
                          setBookingData={setBookingData}
                          clearAllFilter={clearAllFilter}
                          setSelectedRows={setSelectedRows}
                          setAllEditedRows={setAllEditedRows}
                          bookingTableData={bookingTableData}
                          resetMultiFilter={resetMultiFilter}
                          setClearAllFilter={setClearAllFilter}
                          ShowCustomizedView={ShowCustomizedView}
                          updatedBookingData={updatedBookingData}
                          setResetMultiFilter={setResetMultiFilter}
                          setBookingTableData={setBookingTableData}
                          bookingTableFilters={bookingTableFilters}
                          customizeViewFields={customizeViewFields}
                          checkReadWriteAccess={isCapacityManager}
                          showAcpBookingDialog={showAcpBookingDialog}
                          setShowCustomizedView={setShowCustomizedView}
                          setBookingTableFilters={setBookingTableFilters}
                          setCustomizeViewFields={setCustomizeViewFields}
                          setShowAcpBookingDialog={setShowAcpBookingDialog}
                          onSave={onSave}
                          resetKey={resetKey}
                          setFormValid={setFormValid}
                          setDateChangeValue={setDateChangeValue}
                          chartData={chartData}
                          AllEditedTableDataRows={AllEditedTableDataRows}
                          setAllEditedTableDataRows={setAllEditedTableDataRows}
                          availableAcpColumns={DropDownValuesData?.ArtworkAgilityACPPage}
                          capacityWrapFreeText={capacityWrapFreeText}
                          setcapacityWrapFreeText={setcapacityWrapFreeText}
                        />
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                  <AcpFooter
                    loader={loader}
                    onSubmit={onSubmit}
                    handleCancel={handleCancelClick}
                    checkReadWriteAccess={isCapacityManager}
                    formValid={isValid}
                    // formValid={AllEditedTableDataRows?.length ? isValid : false}
                  />
                </div>
              </LoadingOverlay>
            </>
          ) : (
            AccessGroup && AccessGroup?.length && <UnAuthorizedComponent nowrapper={true} />
          )}
        </>
      ),
    },
    {
      name: "bveLoop",
      tabNameForDisplay: "BVE Loop",
      component: tabName === "bveLoop" && (
        <div className="projectSetupParent project-plan-wrapper acp-main">
          <div className="breadCrumbParent">
            <div className="row">
              <div className="col">
                <div>BVE Loop</div>
              </div>
            </div>
          </div>
        </div>
      ),
    },
    {
      name: "reports",
      tabNameForDisplay: "Reports",
      component: tabName === "reports" && (
        <div className="projectSetupParent project-plan-wrapper acp-main">
          <div className="breadCrumbParent">
            <div className="row">
              <div className="col">
                <div>Reports</div>
              </div>
            </div>
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="content-layout">
      <Toast ref={toast} />
      {visible && (
        <AcceptBVEEndDateDialog
          visible={visible}
          setVisible={setVisible}
          selectedRows={selectedRows}
          onSubmit={onSubmit}
        />
      )}
      {showErrorDialog && (
        <AcpDialog
          setLoader={setLoader}
          showErrorDialog={showErrorDialog}
          setShowErrorDialog={setShowErrorDialog}
          errorMsgArr={errorMsgArr}
        />
      )}
      {showAcpBookingDialog && (
        <AcpCommonDialog
          tabName={tabName}
          modalType={modalType}
          suppliers={suppliers}
          fetchData={fetchData}
          fetchAcpBookingBacklog={fetchAcpBookingBacklog}
          actionType={actionType}
          setMainLoader={setLoader}
          setEditedRow={setEditedRow}
          pmPicklistData={pmPicklistData}
          setActionType={setActionType}
          allEditedRows={allEditedRows}
          setAllEditedRows={setAllEditedRows}
          showReportToast={showReportToast}
          setSelectedData={setSelectedRows}
          showAcpBookingDialog={showAcpBookingDialog}
          onReset={onHide}
          setShowAcpBookingDialog={setShowAcpBookingDialog}
          user_group={selectedBU?.length ? selectedBU : validBu}
          dashboardPMTableDataRefresh={dashboardPMTableDataRefresh}
          selectedData={AcpCommonService.findUniqueByKey(selectedRows, "UniqueID")}
          onSave={onSave}
          setOnSave={setOnSave}
          setAllEditedTableDataRows={setAllEditedTableDataRows}
        />
      )}
      {showAcpPlanDialog && (
        <AcpPlanningDialog
          setLoader={setLoader}
          showAcpPlanDialog={showAcpPlanDialog}
          setShowAcpPlanDialog={setShowAcpPlanDialog}
          selectedTask={selectedTask}
          setSaveChangesOption={setSaveChangesOption}
          selectedProject={selectedProject}
          setFormValid={setFormValid}
          setLoadTaskTable={setLoadTaskTable}
          setLoadProjectTable={setLoadProjectTable}
          setSelectedProject={setSelectedProject}
          setSelectedTask={setSelectedTask}
          activeTable={activeTable}
          setIsTaskData={setIsTaskData}
          setIsProjectData={setIsProjectData}
          saveFlag={saveFlag}
          setSaveFlag={setSaveFlag}
        />
      )}
      <div className="tabular-view acp">
        <TabsComponent
          className="booking-tabs"
          tabName={tabName}
          items={itemsData}
          setTabName={setTabName}
          disabled={
            (tabName === "dashboard" &&
              buRegionList?.length &&
              buRegionList?.length > 1 &&
              !AcpService.isUBN(selectedDropdownValue) &&
              !Object.keys(selectedDropdownValue)?.length) ||
            (tabName === "dashboard" && validBu?.length === 0)
          }
          basePage={url[1]}
          isValid={isValid}
          setAllEditedTableDataRows={setAllEditedTableDataRows}
          checkDraftChanges={checkDraftChanges}
        />
      </div>
      {/* UnsavedChangesDialog popup*/}
      <UnsavedChangesDialog
        visible={showDialog}
        onConfirm={confirmNavigation}
        onCancel={cancelNavigation}
      />
    </div>
  );
}

export default CapacityManagement;
